// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header[data-v-4db99d46]{background-color:var(--c-white)}.header-contract[data-v-4db99d46]{padding:30px 20px 20px}.header--interactive .header-contract[data-v-4db99d46]{padding:0 20px}.header--interactive .header__title[data-v-4db99d46]{padding:16px 24px 0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
